/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/select/custom-elements';

import { defineCustomElement as defineOsdsSelect } from '@ovhcloud/ods-stencil/components/select/custom-elements/osds-select.js';
import { defineCustomElement as defineOsdsSelectGroup } from '@ovhcloud/ods-stencil/components/select/custom-elements/osds-select-group.js';
import { defineCustomElement as defineOsdsSelectOption } from '@ovhcloud/ods-stencil/components/select/custom-elements/osds-select-option.js';

export const OsdsSelect = /*@__PURE__*/createReactComponent<JSX.OsdsSelect, HTMLOsdsSelectElement>('osds-select', undefined, undefined, defineOsdsSelect);
export const OsdsSelectGroup = /*@__PURE__*/createReactComponent<JSX.OsdsSelectGroup, HTMLOsdsSelectGroupElement>('osds-select-group', undefined, undefined, defineOsdsSelectGroup);
export const OsdsSelectOption = /*@__PURE__*/createReactComponent<JSX.OsdsSelectOption, HTMLOsdsSelectOptionElement>('osds-select-option', undefined, undefined, defineOsdsSelectOption);
